import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\OlyTar\\verdon_consulting\\src\\components\\phld\\PhldSite.tsx");
